import React, { useCallback, useEffect, useState } from "react";

import { getAdminCourse, getAllAdminModules, getMethods, updateCourse } from "services";

import { useCancelAsyncOnUnmount, useParams } from "utils";

import { AdminHead, ErrorBoundary, Form, MainPage, Tabs, Message as message } from "components";

import { Chapters } from "pages/admin/content/components/Chapters";
import { CourseDetailsForm } from "pages/admin/content/components/CourseDetailsForm";

export const CourseUpdate = () => {
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [methods, setMethods] = useState([]);
  const [modules, setModules] = useState([]);
  const signal = useCancelAsyncOnUnmount()();
  const [form] = Form.useForm();

  const { defaultTab, id } = useParams();

  const loadCourse = useCallback(
    (onComplete) => {
      setLoading(true);

      getAdminCourse({
        courseId: id,
        signal,
      })
        .then((res) => {
          setCourse(res);

          if (onComplete) {
            onComplete();
          }
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [id, signal]
  );

  const loadModules = useCallback(() => {
    getAllAdminModules({
      signal,
    }).then((res) => {
      setModules(res);
    });
  }, [signal]);

  const loadMethods = useCallback(() => {
    getMethods({
      signal,
    }).then((res) => {
      setMethods(res);
    });
  }, [signal]);

  const handleCourseUpdate = (v) => {
    setLoading(true);

    updateCourse({
      ...v,
      courseId: id,
      signal,
    })
      .then(() => {
        message({
          content: "The gremlins accepted your sacrifice and will consume it! Nom nom nom",
          icon: "gremlin",
        });
        loadCourse(() => {
          form.resetFields();
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadCourse();
    loadMethods();
    loadModules();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <ErrorBoundary>
        <AdminHead course link={"/content/courses"} title={"Update a course"} tooltipText={"Back to courses"} />
      </ErrorBoundary>
      <Tabs
        defaultActiveKey={defaultTab}
        size="small"
        items={[
          {
            label: "Course Details",
            key: "course",
            children: (
              <ErrorBoundary>
                <CourseDetailsForm
                  complete={handleCourseUpdate}
                  course={course}
                  isEditing
                  loading={loading}
                  methods={methods}
                  modules={modules}
                  setLoading={setLoading}
                  form={form}
                />
              </ErrorBoundary>
            ),
          },
          {
            label: "Course Chapters",
            key: "chapters",
            children: course && (
              <ErrorBoundary>
                <Chapters courseId={course.id} />
              </ErrorBoundary>
            ),
            disabled: !course,
          },
        ]}
      />
    </MainPage>
  );
};
